import type { IconProps } from './../../models/icon';

export function BillIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill="#fff"
        d="M12.0001 14.5714C13.4203 14.5714 14.5716 13.4202 14.5716 12C14.5716 10.5798 13.4203 9.42856 12.0001 9.42856C10.58 9.42856 9.42871 10.5798 9.42871 12C9.42871 13.4202 10.58 14.5714 12.0001 14.5714Z"
      />
      <path
        fill={secondaryColor}
        fillRule="evenodd"
        d="M2.57171 4.28572H21.4289C22.3757 4.28572 23.1431 5.05324 23.1431 6.00001V18C23.1431 18.9468 22.3757 19.7143 21.4289 19.7143H2.57171C1.62493 19.7143 0.857422 18.9468 0.857422 18V6.00001C0.857422 5.05324 1.62493 4.28572 2.57171 4.28572ZM14.5717 12C14.5717 13.4202 13.4204 14.5714 12.0003 14.5714C10.5801 14.5714 9.42885 13.4202 9.42885 12C9.42885 10.5798 10.5801 9.42858 12.0003 9.42858C13.4204 9.42858 14.5717 10.5798 14.5717 12Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12.0001 14.5714C13.4203 14.5714 14.5716 13.4202 14.5716 12C14.5716 10.5798 13.4203 9.42856 12.0001 9.42856C10.58 9.42856 9.42871 10.5798 9.42871 12C9.42871 13.4202 10.58 14.5714 12.0001 14.5714Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M21.4289 4.28572H2.57171C1.62493 4.28572 0.857422 5.05324 0.857422 6.00001V18C0.857422 18.9468 1.62493 19.7143 2.57171 19.7143H21.4289C22.3757 19.7143 23.1431 18.9468 23.1431 18V6.00001C23.1431 5.05324 22.3757 4.28572 21.4289 4.28572Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M5.14307 8.57144H6.00021"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M18 15.4286H18.8571"
      />
    </svg>
  );
}
